export default __webpack_public_path__ + "fonts/Roboto-500-vietnamese19.woff2";